import { X } from 'lucide-react';
import { todayStr, PAY_METHODS } from '../../lib/format';
import { MoneyInput } from '../MoneyInput';

export function PaymentEntries({ entries, setEntries, total }) {
  const paidTotal = entries.reduce((s, e) => s + (Number(e.amount) || 0), 0);
  const dpCount = entries.filter((e) => e.kind === 'dp').length;

  const setEntry = (i, patch) => setEntries(entries.map((e, j) => (j === i ? { ...e, ...patch } : e)));

  return (
    <div className="space-y-3">
      <div className="flex gap-1.5 flex-wrap">
        <button type="button" data-testid="pay-lunas-button"
          onClick={() => setEntries([{ amount: total, method: 'cash', date: todayStr(), kind: 'pelunasan' }])}
          className="rounded-full bg-success/10 text-success px-3 py-1 text-[11px] font-bold">Lunas</button>
        <button type="button" data-testid="pay-dp50-button"
          onClick={() => setEntries([{ amount: Math.round(total / 2), method: 'cash', date: todayStr(), kind: 'dp' }])}
          className="rounded-full bg-caramel/20 text-[#8a5a2e] px-3 py-1 text-[11px] font-bold">DP 50%</button>
        <button type="button" data-testid="pay-clear-button" onClick={() => setEntries([])}
          className="rounded-full bg-neutral-100 text-neutral-600 px-3 py-1 text-[11px] font-bold">Belum Bayar</button>
      </div>

      {entries.map((e, i) => (
        <div key={i} data-testid={`pay-entry-${i}`} className="rounded-xl border border-border bg-ivory/60 p-3 space-y-2">
          <div className="flex items-center justify-between">
            <span className={`rounded-full px-2.5 py-0.5 text-[10px] font-bold ${e.kind === 'pelunasan' ? 'bg-success/10 text-success' : 'bg-caramel/20 text-[#8a5a2e]'}`}>
              {e.kind === 'pelunasan' ? 'Pelunasan' : `DP${dpCount > 1 ? ` ${entries.slice(0, i + 1).filter((x) => x.kind === 'dp').length}` : ''}`}
            </span>
            <button type="button" data-testid={`pay-entry-remove-${i}`} onClick={() => setEntries(entries.filter((_, j) => j !== i))} className="p-1 text-danger hover:bg-danger/10 rounded-lg">
              <X size={13} />
            </button>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
            <MoneyInput data-testid={`pay-amount-${i}`} value={e.amount}
              onChange={(v) => setEntry(i, { amount: v })} placeholder="Jumlah"
              className="rounded-lg border border-input bg-white px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-brown/30" />
            <select data-testid={`pay-method-${i}`} value={e.method} onChange={(ev) => setEntry(i, { method: ev.target.value })}
              className="rounded-lg border border-input bg-white px-2 py-2 text-sm outline-none focus:ring-2 focus:ring-brown/30">
              {PAY_METHODS.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
            </select>
            <input data-testid={`pay-date-${i}`} type="date" value={e.date} onChange={(ev) => setEntry(i, { date: ev.target.value })}
              className="col-span-2 sm:col-span-1 rounded-lg border border-input bg-white px-2 py-2 text-sm outline-none focus:ring-2 focus:ring-brown/30" />
          </div>
        </div>
      ))}

      <div className="flex gap-2">
        <button type="button" data-testid="pay-add-dp"
          onClick={() => setEntries([...entries, { amount: '', method: 'cash', date: todayStr(), kind: 'dp' }])}
          className="rounded-full border border-brown/30 text-brown px-3.5 py-1.5 text-[11px] font-bold hover:bg-brown/5">
          + DP lainnya
        </button>
        {paidTotal < total && total > 0 && (
          <button type="button" data-testid="pay-add-pelunasan"
            onClick={() => setEntries([...entries, { amount: total - paidTotal, method: 'transfer', date: todayStr(), kind: 'pelunasan' }])}
            className="rounded-full border border-success/40 text-success px-3.5 py-1.5 text-[11px] font-bold hover:bg-success/5">
            + Pelunasan
          </button>
        )}
      </div>
      <p className="text-[11px] text-mocha">DP bisa ditambah berkali-kali untuk pembayaran bertahap — masing-masing dengan metode & tanggalnya.</p>
    </div>
  );
}
